import React from 'react';
import { FaHeart, FaGithub, FaEnvelope } from 'react-icons/fa';
import { useTranslation } from '@/contexts/TranslationContext';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">SmartPaw Care</h3>
            <p className="text-gray-400">
              {t('footer.tagline')}
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="#venues" className="hover:text-white transition-colors">
                  {t('footer.findSpot')}
                </a>
              </li>
              <li>
                <a href="#dogs" className="hover:text-white transition-colors">
                  {t('footer.sponsorDog')}
                </a>
              </li>
              <li>
                <a href="/admin/login" className="hover:text-white transition-colors">
                  {t('footer.adminLogin')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.contact')}</h4>
            <div className="space-y-2 text-gray-400">
              <p className="flex items-center gap-2">
                <FaEnvelope />
                <a href="mailto:info@smartpawcare.com" className="hover:text-white transition-colors">
                  info@smartpawcare.com
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p className="flex items-center justify-center gap-2">
            {t('footer.madeWith')} <FaHeart className="text-red-500" /> {t('footer.forStrays')}
          </p>
          <p className="mt-2 text-sm">
            {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
